import React from 'react';
import { Helmet } from 'react-helmet-async';

import Breadcrumb, {BreadcrumbItem} from '../../components/Breadcrumb';
 
const ContactComplete = () => {

    // パンくずリストリンク
    const breadcrumbItems:BreadcrumbItem[] = [
        {'label': 'ホーム', 'path': '/'},
        {'label': 'お問合せ', 'path':'/contact/index.html'}
    ]

    //
    return (
        <>
        <Helmet>
            <title>お問合せ：完了 | 予算書・決算書データベース</title>
        </Helmet>
        <main id="main" className="l-contents-main">
        <div className="l-contents l-contents--head">
            <div className="l-contents__inner">

            <Breadcrumb itemLists = {breadcrumbItems} />

            <div className="c-blk-head">
                <h1 className="c-heading-lv1">お問合せ：完了</h1>
            </div>
            </div>
        </div>
        <div className="l-contents l-contents--body">
            <div className="l-contents__inner">
            <div className="c-panel">
                <div className="c-form c-contact-complete">

                <ol className="c-form-flow">
                    <li className="c-form-flow__step">
                        <span className="c-form-flow__step-mark">1</span>
                        <span className="c-form-flow__step-text">内容の入力</span>
                    </li>
                    <li className="c-form-flow__step">
                        <span className="c-form-flow__step-mark">2</span>
                        <span className="c-form-flow__step-text">確認</span>
                    </li>
                    <li className="c-form-flow__step" aria-current="step">
                        <span className="c-form-flow__step-mark">3</span>
                        <span className="c-form-flow__step-text">完了</span>
                    </li>
                </ol>
                <div className="c-blk-txt">
                    <p>お問合せが完了しました。</p>
                    <p>ご入力いただいたメールアドレス宛てに、お問合せ完了の自動返信メールをお送りしております。</p>
                    <p>自動返信メールが届かない場合は、迷惑メールフォルダに振り分けられているまたは受信拒否となっている可能性や、メールアドレスの誤入力の可能性があります。</p>
                    <p>迷惑メールフォルダや受信設定をご確認の上、@mof.go.jpのドメインを受信可能なドメインとして設定していただくか、メールアドレスの誤入力の可能性がある場合は、お手数ですが正しいメールアドレスで再度お問合せください。</p>
                </div>

                </div>
            </div>
            </div>
        </div>
        </main>
        </>
    )
};

export default ContactComplete;